/* ==========================================================================
   RECREATE — kiosk attract loop + idle reset
   --------------------------------------------------------------------------
   >>> TEMPORARY: FORCE_ON is true. <<<
   Normally this only runs when a page is loaded with ?kiosk=1. It is forced
   on for EVERY visitor right now because the kiosk machine can't be reached
   to change its start URL. That means online shoppers also get the eyes, the
   idle cart-clear and the periodic refresh.

   TO PUT IT BACK: set FORCE_ON to false. Nothing else needs changing.

   Escape hatch while forced: loading any page with ?kiosk=0 switches it off
   for that browser until the tab is closed.

   Timings (seconds):
     attract  45   idle before the eyes appear
     hop      30   how long the eyes stay on one perch before moving
     reset   180   idle before clearing the cart and returning home
     reload  300   page refresh, but only once idle
   ========================================================================== */
(function () {
  'use strict';

  var FORCE_ON = true;          // <-- flip to false to return to kiosk-only

  var KEY = 'recreate-kiosk';
  var OFF = 'recreate-kiosk-off';
  var CFG = 'recreate-kiosk-cfg';

  function store(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function drop(k) { try { sessionStorage.removeItem(k); } catch (e) {} }

  var params = new URLSearchParams(location.search);
  var flag = params.get('kiosk');

  if (flag === '0') { store(OFF, '1'); drop(KEY); drop(CFG); return; }
  if (read(OFF) === '1') return;

  var cfg = { attract: 45, reset: 180 };
  try { cfg = JSON.parse(read(CFG)) || cfg; } catch (e) {}

  if (flag === '1') {
    store(KEY, '1');
    if (params.get('attract')) cfg.attract = parseInt(params.get('attract'), 10) || cfg.attract;
    if (params.get('reset') !== null) cfg.reset = parseInt(params.get('reset'), 10);
    store(CFG, JSON.stringify(cfg));
  }

  if (!FORCE_ON && read(KEY) !== '1') return;

  var ATTRACT_MS = Math.max(5, cfg.attract) * 1000;
  var RESET_MS = cfg.reset > 0 ? Math.max(30, cfg.reset) * 1000 : 0;
  var HOP_MS = Math.max(4, parseInt(params.get('hop') || '30', 10)) * 1000;

  /* ---------- Periodic refresh ------------------------------------------
     So the kiosk picks up theme changes without anyone standing at it.
     Idle-gated on purpose: it waits until the screen has been untouched for
     a minute and nobody is typing, so a live shopper is never yanked out of
     their own session. An idle kiosk always qualifies. */

  var RELOAD_MS = 300000;
  var IDLE_BEFORE_RELOAD = 60000;
  var loadedAt = Date.now();
  var lastActivity = Date.now();

  function busyTyping() {
    var a = document.activeElement;
    return !!a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName);
  }

  setInterval(function () {
    if (Date.now() - loadedAt < RELOAD_MS) return;
    if (Date.now() - lastActivity < IDLE_BEFORE_RELOAD) return;
    if (busyTyping()) return;
    location.reload();
  }, 15000);

  /* ---------- Build the layer ------------------------------------------- */

  var EYES =
    '<svg class="rk__face" viewBox="0 0 230 130" aria-hidden="true">' +
      '<g class="rk__eye">' +
        '<ellipse class="rk__white" cx="72" cy="66" rx="50" ry="50"/>' +
        '<circle class="rk__pupil" cx="72" cy="70" r="22"/>' +
        '<circle class="rk__shine" cx="64" cy="62" r="7"/>' +
      '</g>' +
      '<g class="rk__eye rk__eye--b">' +
        '<ellipse class="rk__white" cx="166" cy="72" rx="42" ry="42"/>' +
        '<circle class="rk__pupil" cx="166" cy="76" r="18"/>' +
        '<circle class="rk__shine" cx="159" cy="69" r="5.5"/>' +
      '</g>' +
    '</svg>';

  var HAND =
    '<svg viewBox="0 0 48 48" aria-hidden="true">' +
      '<circle cx="24" cy="24" r="22" fill="currentColor"/>' +
      '<path d="M14 24h17M25 16l9 8-9 8" fill="none" stroke="#000" stroke-width="4.5" ' +
            'stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var layer = document.createElement('div');
  layer.className = 'rk';
  layer.setAttribute('aria-hidden', 'true');
  layer.innerHTML =
    '<div class="rk__hand">' + HAND + '</div>' +
    '<div class="rk__eyes rk__eyes--bl">' + EYES + '<div class="rk__bubble"></div></div>';

  var hand, bubble, eyes, target = null, showing = false;

  /* The eyes hop round the screen so the attract loop keeps catching the eye
     instead of turning into wallpaper in one corner. */
  var SPOTS = ['bl', 'tr', 'br', 'tl'];
  var spotIndex = 0;
  var hopTimer = null;

  function mount() {
    document.body.appendChild(layer);
    hand = layer.querySelector('.rk__hand');
    bubble = layer.querySelector('.rk__bubble');
    eyes = layer.querySelector('.rk__eyes');
    schedule();
  }

  /* ---------- Find something worth pointing at ---------------------------
     [data-attract] is the general opt-in hook: any section can mark its own
     primary action with it. The lookbook sets it on whichever slide is
     currently showing, so the eyes follow the slideshow. */

  var CANDIDATES = [
    ['[data-attract]', 'TAP TO SHOP'],
    ['[data-add-to-cart]:not([disabled])', 'TAP TO ADD'],
    ['.product__main-media', 'TAP TO ENLARGE'],
    ['.hero__buttons .btn', 'TAP TO SHOP'],
    ['.tile', 'HAVE A LOOK'],
    ['.card__title a', 'HAVE A LOOK'],
    ['[data-drawer-toggle]', 'BROWSE THE SHOP']
  ];

  function onScreen(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var vh = window.innerHeight, vw = window.innerWidth;
    return r.top > 8 && r.left > 8 && r.bottom < vh - 8 && r.right < vw - 8;
  }

  function findTarget() {
    for (var i = 0; i < CANDIDATES.length; i++) {
      var els = document.querySelectorAll(CANDIDATES[i][0]);
      for (var j = 0; j < els.length; j++) {
        if (onScreen(els[j])) return { el: els[j], label: CANDIDATES[i][1] };
      }
    }
    return null;
  }

  /* ---------- Aiming ----------------------------------------------------- */

  function placeHand(el) {
    var r = el.getBoundingClientRect();
    var x, y, deg;
    var midY = r.top + r.height / 2;

    if (r.left > 110) {
      x = r.left - 46; y = midY; deg = 0;
    } else if (window.innerWidth - r.right > 110) {
      x = r.right + 46; y = midY; deg = 180;
    } else {
      x = r.left + r.width / 2; y = r.top - 46; deg = 90;
    }

    hand.style.transform = 'translate(' + Math.round(x) + 'px,' + Math.round(y) + 'px) rotate(' + deg + 'deg)';
    return { x: x, y: y };
  }

  function lookAt(pt) {
    var box = layer.querySelector('.rk__face').getBoundingClientRect();
    var cx = box.left + box.width / 2, cy = box.top + box.height / 2;
    var dx = pt.x - cx, dy = pt.y - cy;
    var len = Math.sqrt(dx * dx + dy * dy) || 1;
    var reach = 11;
    layer.style.setProperty('--px', Math.round(dx / len * reach) + 'px');
    layer.style.setProperty('--py', Math.round(dy / len * reach) + 'px');
  }

  var wanderTimer = null;

  function lookAround() {
    var cx = window.innerWidth / 2, cy = window.innerHeight / 2;
    var jitter = [[0, 0], [-90, 40], [110, -30], [40, 90], [-60, -50]];
    var i = 0;
    lookAt({ x: cx, y: cy });
    wanderTimer = setInterval(function () {
      var j = jitter[i++ % jitter.length];
      lookAt({ x: cx + j[0], y: cy + j[1] });
    }, 1800);
  }

  function stopWander() {
    if (wanderTimer) { clearInterval(wanderTimer); wanderTimer = null; }
  }

  function applySpot() {
    eyes.className = 'rk__eyes rk__eyes--' + SPOTS[spotIndex];
  }

  function aim() {
    stopWander();
    if (target) { target.classList.remove('rk-target'); target = null; }

    var found = findTarget();
    if (found) {
      target = found.el;
      target.classList.add('rk-target');
      bubble.textContent = found.label;
      hand.classList.add('is-on');
      lookAt(placeHand(target));
    } else {
      bubble.textContent = 'TAP TO SHOP';
      hand.classList.remove('is-on');
      lookAround();
    }
  }

  /* ---------- Show / hop / hide ------------------------------------------ */

  function hop() {
    if (!showing) return;
    layer.classList.remove('is-on');
    setTimeout(function () {
      if (!showing) return;
      spotIndex = (spotIndex + 1) % SPOTS.length;
      applySpot();
      aim();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (showing) layer.classList.add('is-on');
        });
      });
    }, 650);
  }

  function show() {
    if (showing) return;
    showing = true;
    applySpot();
    aim();
    layer.classList.add('is-on');
    clearInterval(hopTimer);
    hopTimer = setInterval(hop, HOP_MS);
  }

  function hide() {
    if (!showing) return;
    showing = false;
    clearInterval(hopTimer);
    hopTimer = null;
    stopWander();
    layer.classList.remove('is-on');
    hand.classList.remove('is-on');
    if (target) { target.classList.remove('rk-target'); target = null; }
  }

  /* ---------- Idle timers ------------------------------------------------ */

  var tAttract = null, tReset = null;

  function schedule() {
    clearTimeout(tAttract);
    clearTimeout(tReset);
    tAttract = setTimeout(show, ATTRACT_MS);
    if (RESET_MS) tReset = setTimeout(reset, RESET_MS);
  }

  function wake() {
    lastActivity = Date.now();
    hide();
    schedule();
  }

  function reset() {
    if (busyTyping()) { wake(); return; }
    var done = function () {
      if (location.pathname === '/') { wake(); return; }
      location.href = '/';
    };
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '{}'
    }).then(done, done);
  }

  ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll', 'mousemove'].forEach(function (ev) {
    window.addEventListener(ev, wake, { passive: true, capture: true });
  });

  window.addEventListener('resize', function () {
    if (showing) aim();
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
